import MaintenanceDetailAssets from "./MaintenanceDetailAssets";
export default MaintenanceDetailAssets;
